export class AddCommentVo {
    id: any;
    comment: any;
    usrName: any;
}